import { fixedsHeader, generateColors, globalSearch, initFancyBox, initSearch } from "@common/utils/initUtils";
import { handleSendInquiry, ImportBundle, lazyLoad } from "@common/utils/utils";
import Swiper from "swiper11";
import { Autoplay, EffectFade, Pagination } from "swiper11/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
$(function () {
  if (window.innerWidth === 1350 || window.innerWidth === 412) {
    $(document).one("mousemove", () => {
      initFunction();
    });
    $(document).one("touchmove", () => {
      initFunction();
    });
    $(document).one("scroll", () => {
      initFunction();
    });
  } else {
    initFunction();
  }
});

/*! Event End */
let initFunction = () => {
  lazyLoad();
  initEvent();
  ImportBundle({ type: "css", isIndex: true }, ["https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css"]);
  gsap.registerPlugin(ScrollTrigger);
  __header();
  _banner();
  _about();
  _product();
  _new();
  _contact();
  initFunction = () => {};
};
function initEvent() {
  fixedsHeader("page__header");
  globalSearch();
  initSearch();
  initFancyBox();
  generateColors($("html body").css("--themeColor"), { setTo: true });
}

const __header = () => {
  const selector = $(".page__header");
  if (!selector.length) return;
  let currentIndex: number | undefined = undefined;
  const lis = selector.find(".header-right-nav .page__nav .list > li");
  lis.each((i, li) => {
    let timer: NodeJS.Timeout | undefined = undefined;
    $(li).on("mouseenter", (e) => {
      const sub = $(e.currentTarget).find(".sub-wrapper");
      if (!sub.length) return;
      const target = e.currentTarget;
      const idx = $(target).index();
      if (currentIndex === idx) {
        if (timer) {
          clearTimeout(timer);
          timer = undefined;
        }
      }
      currentIndex = idx;
      $(target).siblings("li").removeClass("is-show");
      if (timer) {
        clearTimeout(timer);
        timer = undefined;
      }
      $(target).addClass("is-show");
    });
    $(li).on("mouseleave", (e) => {
      e.preventDefault();
      e.stopPropagation();
      timer = setTimeout(() => {
        $(li).removeClass("is-show");
        currentIndex = undefined;
      }, 150);
    });
  });
};
const _banner = () => {
  const selector = $("._index_ .index-banner");
  if (!selector.length) return;
  new Swiper(selector.find(".swiper-box .swiper")[0], {
    modules: [Autoplay, Pagination, EffectFade],
    loop: true,
    speed: 850,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: selector.find(".custom-swiper-pagination")[0],
      clickable: true,
    },
    on: {
      slideChangeTransitionStart: (swiper) => {
        const title = $(swiper.slides).find(".text-wrap .banner-title");
        const img = $(swiper.slides).find(".img-box");
        gsap
          .timeline()
          .to(
            title,
            {
              yPercent: 100,
              autoAlpha: 0,
            },
            0
          )
          .to(
            img,
            {
              scale: 1,
            },
            0
          )
          .to(
            $(swiper.slides[swiper.activeIndex]).find(".img-box"),
            {
              scale: 1.15,
              autoAlpha: 1,
              duration: 1.5,
              ease: "none",
            },
            "<25%"
          )
          .to(
            $(swiper.slides[swiper.activeIndex]).find(".text-wrap .banner-title"),
            {
              yPercent: 0,
              autoAlpha: 1,
              duration: 0.75,
            },
            "<"
          );
      },
    },
  });
};
const _about = () => {
  const selector = $("._index_ .index-about");
  if (!selector.length) return;
  const textWrap = selector.find(".text-wrap");
  const aboutBottom = selector.find(".about-bottom");
  const imgBox = selector.find(".img-box");

  const T = gsap.timeline({
    scrollTrigger: {
      trigger: selector,
      start: "top bottom-=20%",
      end: "bottom top+=20%",
      onToggle: ({ isActive }) => {
        if (isActive) {
          T.play();
        } else {
          T.reverse(1);
        }
        console.log(self);
      },
    },
  });
  // T.from(imgBox, {
  //   autoAlpha: 0,
  //   duration: 0.3,
  //   ease: "circ.in",
  // });
  T.from(
    imgBox,
    {
      autoAlpha: 0,
      scale: 0.5,
      duration: 1.2,
      ease: "circ.inOut",
    },
    "<"
  );
  T.from(
    textWrap,
    {
      autoAlpha: 0,
      xPercent: 50,
      duration: 1,
    },
    "<50%"
  );
  T.from(
    aboutBottom,
    {
      autoAlpha: 0,
      xPercent: 30,
      duration: 0.75,
    },
    "<10%"
  );
};
const _product = () => {
  const selector = $("._index_ .index-product");
  if (!selector.length) return;
  const title = selector.find("header > .index-title");
  const btn = selector.find("footer > .index-btn");
  const list = selector.find(".product-right .list");
  const T = gsap.timeline({
    scrollTrigger: {
      trigger: selector.find("._container_"),
      start: "top bottom-=25%",
      end: "bottom top+=25%",
      toggleActions: "play reverse play reverse",
    },
  });
  T.from(
    list,
    {
      y: 180,
      autoAlpha: 0,
    },
    0
  );
  T.from(
    title,
    {
      yPercent: 100,
    },
    "<75%"
  );
  T.from(
    btn,
    {
      yPercent: 100,
    },
    "<"
  );
};
const _new = () => {
  const selector = $("._index_ .index-new");
  if (!selector.length) return;
  const titleBlock = selector.find("header > *");
  const textLeft = selector.find(".text_left");
  const T = gsap.timeline({
    scrollTrigger: {
      trigger: selector,
      start: "top center",
      end: "bottom center",
      toggleActions: "play none none reset",
    },
  });
  T.from(selector, {
    "--text-clip": "100%",
    duration: 1.15,
  });
  T.from(
    titleBlock,
    {
      yPercent: 100,
      autoAlpha: 0,
      duration: 1,
      stagger: 0,
    },
    "<50%"
  );
  T.from(
    textLeft,
    {
      yPercent: 100,
      duration: 0.85,
    },
    "<75%"
  );
};
const _contact = () => {
  const selector = $(".common-contact");
  if (!selector.length) return;
  handleSendInquiry({
    formId: "#CommonForm",
    trigger: "#CommonSubmit",
    opts: {
      onSuccess: (res) => {
        if (res.code == 200) {
          location.href = "/page/thank.html";
        } else {
          alert(res.msg);
        }
      },
    },
  });
  selector.find("input,textarea").on("blur", (e) => {
    const target = $(e.currentTarget);
    const parent = target.parents(".input-box");
    if (target.val() !== "") {
      parent.addClass("valid");
    } else {
      parent.removeClass("valid");
    }
  });
};
